var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentno"},[_c('img',{attrs:{"src":require("../../assets/question_icon_01.png")}}),_c('span',{staticClass:"content-span"},[_vm._v(_vm._s(_vm.content)+"，敬请期待")]),_vm._t("result")],2)}
var staticRenderFns = []

export { render, staticRenderFns }